import { Component, HostBinding, Input } from '@angular/core';
import {
  formatDetailValue,
  projectDetailItems,
  type DetailSectionItem,
} from './detail-section.util';

let nextDetailSectionId = 0;

/**
 * Frame with a short title and label/value rows.
 * Optional `items` follow the shared field rules. Projected `app-detail-item`
 * nodes and any other content stay explicit slots.
 */
@Component({
  selector: 'app-detail-section',
  templateUrl: './detail-section.component.html',
  styleUrls: ['./detail-section.component.scss'],
  host: { class: 'tt-detail-section' },
})
export class DetailSectionComponent {
  @Input() title = '';
  @Input() headingId = '';
  @Input() items: DetailSectionItem[] | null = null;

  private readonly autoId = `tt-detail-section-${++nextDetailSectionId}`;

  @HostBinding('attr.aria-labelledby')
  get labelledBy(): string | null {
    return this.title ? this.resolvedHeadingId : null;
  }

  get resolvedHeadingId(): string {
    return this.headingId || this.autoId;
  }

  get visibleItems(): DetailSectionItem[] {
    return projectDetailItems(this.items);
  }

  formatValue(value: unknown): string {
    return formatDetailValue(value);
  }

  trackItem(index: number, item: DetailSectionItem): string {
    return `${item.key ?? ''}::${item.label}::${index}`;
  }
}
